import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-dialog',
  template: `
    @if (dynamicDialogConfig.data.description; as description) {
      <p data-testid="modal-error-description">
        {{ description }}
      </p>
    }
    @if (dynamicDialogConfig.data.customError; as customError) {
      <p data-testid="modal-error-custom-error" class="custom-error">
        {{ customError }}
      </p>
    }
    @if (dynamicDialogConfig.data.type; as dialogType) {
      <p class="modal-ok-image">
        <img
          [src]="'assets/icon/modal-' + dialogType + '.png'"
          data-testid="modal-ok-image"
          width="25%"
        />
      </p>
    }

    @if (dynamicDialogConfig.data.title; as title) {
      <p class="modal-text-title">
        {{ title }}
      </p>
    }
  `,
  styles: [
    `
      @use 'sass:map';
      @use '../../../theme/colors' as *;

      .custom-error {
        font-size: 0.8rem;
      }
      .modal-ok-image {
        text-align: center;
      }

      .modal-text-title {
        color: map.get($mysales-colors, primary);
        font-weight: bold;
        padding: 1rem 0;
        text-align: center;
      }
    `
  ],
  standalone: true
})
export class DialogComponent {
  readonly dynamicDialogConfig = inject(DynamicDialogConfig);
}
